import { render } from "./ProductPickerDialog.vue?vue&type=template&id=2b502a58&scoped=true"
import script from "./ProductPickerDialog.vue?vue&type=script&lang=js"
export * from "./ProductPickerDialog.vue?vue&type=script&lang=js"

import "./ProductPickerDialog.vue?vue&type=style&index=0&id=2b502a58&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b502a58"]])

export default __exports__